import React, { useEffect, useState } from "react";

const SeeServiceList = ({ reload, setReload, service }) => {
  const [statusChange, setStatusChange] = useState(service.status);
  // const location = useLocation();
  const handleStatus = (e) => {
    const updateStatus = e.target.value;
    console.log(updateStatus);
    setStatusChange(updateStatus);
  };
  useEffect(() => {
    fetch(
      `https://gentle-escarpment-52580.herokuapp.com/updateStatus/${service._id}`,
      {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },

        body: JSON.stringify({ status: statusChange }),
      }
    )
      .then((response) => response.json())
      .then((response) => {
        if (response) {
          alert("Updated successful");
          setReload(!reload);
        }
      });
  }, [statusChange]);

  return (
    <tr>
      <td>{service.name}</td>
      <td>{service.email}</td>
      <td>{service.project}</td>
      <td>{service.projectDetails}</td>
      <td>
        <select
          className={`form-control ${
            (service.status === "Pending" && "alert-danger") ||
            (service.status === "Ongoing" && "alert-warning") ||
            (service.status === "Done" && "alert-success")
          } pr-5`}
          onChange={handleStatus}
        >
          {service.status === "Pending" ? (
            <option className="text-danger" selected>
              Pending
            </option>
          ) : (
            <option className="text-danger">Pending</option>
          )}
          {service.status === "Ongoing" ? (
            <option className="text-warning" selected>
              Ongoing
            </option>
          ) : (
            <option className="text-warning">Ongoing</option>
          )}
          {service.status === "Done" ? (
            <option className="text-success" selected>
              Done
            </option>
          ) : (
            <option className="text-success">Done</option>
          )}
        </select>
      </td>
    </tr>
  );
};

export default SeeServiceList;

//  {
//    <select
//      onChange={(event) => {
//        handleChangeStatus(event, _id);
//      }}
//    >
//      <option value="On going">On going</option>
//      <option value="Done">Done</option>
//    </select>;
//  }
//  const handleChangeStatus = (e) => {
//    console.log(e.target.value);
//  };
